export default {
  ru: {
    empty: 'Пока нет сообщений',
    participant: 'Участник',
    chatAuthor: 'От имени группы или канала',
    edited: 'Изменено',
    readOnly: 'Только просмотр',
    explanation:
      'Сообщения поступают из групп в режиме «Наблюдение». Ответы, удаление сообщений и блокировки пока недоступны.',
  },
  en: {
    empty: 'No messages yet',
    participant: 'Participant',
    chatAuthor: 'Sent as a group or channel',
    edited: 'Edited',
    readOnly: 'View only',
    explanation:
      'Messages are received from groups in Observe mode. Replies, message deletion and member bans are not available yet.',
  },
};
